import apiClient from './apiClient';
import { assertDeployedApiSuccess } from './deployedContracts';

export interface CancelOrderParams {
  reason?: string;
  orderUserId?: string;
  serviceProviderId?: string;
  /** Admin: cancel in-progress orders that customers cannot cancel themselves */
  force?: boolean;
}

export interface CancelOrderResult {
  id: string;
  order_status: string;
  order_remarks?: string;
}

/**
 * POST /order-management/:id/cancel
 * Cancels the order (status CANCELLED) without deleting the row.
 */
export async function cancelOrder(
  orderId: string,
  params: CancelOrderParams = {}
): Promise<CancelOrderResult> {
  const res = await apiClient.post(
    `/order-management/${encodeURIComponent(orderId)}/cancel`,
    {
      reason: params.reason,
      order_user_id: params.orderUserId,
      service_provider_id: params.serviceProviderId,
      force: params.force === true,
    }
  );
  assertDeployedApiSuccess(res.data, 'Failed to cancel order');
  const data = (res.data as { data?: CancelOrderResult })?.data ?? res.data;
  return {
    id: data?.id ?? orderId,
    order_status: data?.order_status ?? 'CANCELLED',
    order_remarks: data?.order_remarks,
  };
}
